export const contacts = {
    email: {
        value: 'info@affiliationspace.com',
        href: 'mailto:info@affiliationspace.com'
    },
    skype: {
        value: 'live:example',
        href: 'skype:live:example?chat'
    },
    whatsapp: {
        value: '+1 (234) 567-890',
        href: 'https://wa.me/1234567890'
    }
}; 